import { ITraveler } from "@common/models";
import { IShareInitializeResponse } from "@common/models/ShareInitializeResponse";
import { ISharingRequest } from "@common/models/SharingRequest";
import { ISharingResponse } from "@common/models/SharingResponse";
import Button from "@components/general/form/Button";
import Label from "@components/general/Label";
import Sharing from "@pages/Sharing";
import Notification from "@service/Notification";
import { Action, participateShare, participateShortenLink } from "@service/proxy";
import Translate from "@service/Translate";
import { FC, useContext, useState } from "react";
import { ParticipateContext } from "./Context";

interface IFeedbackSharingItemProps {
    traveler: ITraveler;
}

export const FeedbackSharingItem: FC<IFeedbackSharingItemProps> = ({ traveler }) => {
    const { tr } = Translate;
    const { participate } = useContext(ParticipateContext);
    const [sharingDialogVisibility, setSharingDialogVisibility] = useState<boolean>(false);
    const [shareInitializeResponse, setShareInitializeResponse] = useState<IShareInitializeResponse>();

    const onCompanionSharing = (sharingRequest: ISharingRequest): Promise<ISharingResponse> => {
        return new Promise((resolve, reject) => {
            sharingRequest.id = participate.id;
            participateShare(Action.POST, { data: sharingRequest })
                .then((response) => {
                    Notification.success("feedback_sharing_msg_successful");
                    resolve(response.content)
                })
                .catch((error) => { reject(); })
        })
    }

    const onCompanionSharingInit = (traveler: ITraveler): Promise<boolean> => {
        return new Promise((resolve) => {
            const sharingRequest: ISharingRequest = { id: participate.id, traveler };
            participateShortenLink(Action.POST, { data: sharingRequest })
                .then((response) => {
                    const shareInitializeResponse: IShareInitializeResponse = {
                        body: tr("feedback_msg_sharing_companions_share_for", `${traveler?.firstName} ${traveler?.lastName}`),
                        email: traveler?.email,
                        mobile: traveler?.mobile,
                        shortenLink: response.content
                    }
                    setShareInitializeResponse(shareInitializeResponse);
                    setSharingDialogVisibility(true);
                })
                .catch((error) => { })
                .finally(() => {
                    resolve(true);
                })
        })
    }

    return (
        <div className="feedback-sharing-companion-items flex justify-between">
            <Button
                icon="icon-share"
                rounded
                width="40px"
                height="40px"
                onClickAsync={() => onCompanionSharingInit(traveler)}
            />
            <Label
                mode="inline"
                dir="ltr"
                icon="icon-account"
                size="xlarge"
                text={`${traveler.firstName} ${traveler.lastName}`}
                fontWeight="bold"
                style={{ maxWidth: "calc(100% - 60px)" }}
            />
            <Sharing
                show={sharingDialogVisibility}
                shareInitializeResponse={shareInitializeResponse}
                traveler={traveler}
                dataSource={participate.fellowTravelers}
                onCloseClick={() => setSharingDialogVisibility(false)}
                onSharingClick={onCompanionSharing}
            />
        </div>

    )
}